// FILE: components/Stack.tsx
// This component arranges children in a vertical stack with consistent gaps using proper Tailwind classes.

import React from 'react';

type StackGap = 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 16 | 20 | 24 | 32;
type StackProps<C extends React.ElementType> = { 
  as?: C; 
  children?: React.ReactNode; 
  className?: string; 
  gap?: StackGap; 
};

const StackFC = <C extends React.ElementType = "div">({ 
  as, 
  children, 
  className = '', 
  gap = 4,
  ...rest
}: StackProps<C> & Omit<React.ComponentPropsWithoutRef<C>, keyof StackProps<C>>) => {
  const Component = as || "div";
  
  // Map gap numbers to Tailwind classes
  const gapClasses = {
    1: 'gap-1',
    2: 'gap-2', 
    3: 'gap-3',
    4: 'gap-4',
    5: 'gap-5',
    6: 'gap-6',
    8: 'gap-8',
    10: 'gap-10',
    12: 'gap-12',
    16: 'gap-16',
    20: 'gap-20',
    24: 'gap-24',
    32: 'gap-32',
  };
  
  const combinedClasses = `flex flex-col ${gapClasses[gap]} ${className}`.trim();
  
  return (
    <Component className={combinedClasses} {...rest}>
      {children}
    </Component>
  );
};

export const Stack = StackFC;
